import type { ReactNode } from 'react';
import type { AlertItem as AlertItemType, AlertKind } from '@interfaces/IAlertItem';
import {
  ShieldIcon,
  ZapIcon,
  TruckIcon,
  PackageIcon,
  WarningTriangleIcon,
} from '@utils/icons';
import styles from './styles.module.css';

const ICON_BY_KIND: Record<AlertKind, ReactNode> = {
  safety: <ShieldIcon size={16} />,
  blocker: <ZapIcon size={16} />,
  delivery: <TruckIcon size={16} />,
  stock: <PackageIcon size={16} />,
  threshold: <WarningTriangleIcon size={16} />,
};

type IAlertItemProps = { alert: AlertItemType };

export function AlertItem({ alert }: IAlertItemProps) {
  return (
    <div
      className={styles.item}
      data-kind={alert.kind}
      data-severity={alert.severity}
      data-testid="alert-item"
    >
      <div className={styles.head}>
        <span className={styles.icon} aria-hidden>{ICON_BY_KIND[alert.kind]}</span>
        <span className={styles.site}>{alert.site}</span>
        <span className={styles.ago}>{alert.ago}</span>
      </div>
      <div className={styles.text}>{alert.text}</div>
    </div>
  );
}
